import { THEME_ACCOUNT_CACHE_KEY, THEME_PREFERENCES, resolveThemeMode, themeCacheKey } from './themeMode';

export function readSystemDark() {
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
}

function isThemePreference(value) {
    return THEME_PREFERENCES.includes(value);
}

export function resolveStoredThemePreference(domain, storage = localStorage) {
    const account = storage.getItem(THEME_ACCOUNT_CACHE_KEY);
    if (isThemePreference(account)) {
        return { preference: account, persist: null };
    }
    const domainValue = storage.getItem(themeCacheKey(domain));
    if (isThemePreference(domainValue)) {
        return { preference: domainValue, persist: domainValue };
    }
    const values = [];
    for (let index = 0; index < storage.length; index += 1) {
        const key = storage.key(index) || '';
        if (!key.startsWith(`${THEME_ACCOUNT_CACHE_KEY}.`)) {
            continue;
        }
        const value = storage.getItem(key);
        if (isThemePreference(value)) {
            values.push(value);
        }
    }
    if (values.length > 0 && values.every((value) => value === values[0]) && values[0] !== 'AUTO') {
        return { preference: values[0], persist: values[0] };
    }
    return { preference: 'AUTO', persist: null };
}

export function readCachedPreference(domain) {
    try {
        const { preference, persist } = resolveStoredThemePreference(domain);
        if (persist) {
            localStorage.setItem(THEME_ACCOUNT_CACHE_KEY, persist);
        }
        return preference === 'AUTO' ? null : preference;
    } catch (error) {
        return null;
    }
}

export function writeCachedPreference(domain, preference) {
    if (!THEME_PREFERENCES.includes(preference)) {
        return;
    }
    try {
        localStorage.setItem(THEME_ACCOUNT_CACHE_KEY, preference);
        localStorage.setItem(themeCacheKey(domain), preference);
    } catch (error) {
        // Private mode can reject storage; the server value still applies in this tab.
    }
}

export function preferenceFromStorageEvent(event, domain) {
    if (!event || (event.key !== THEME_ACCOUNT_CACHE_KEY && event.key !== themeCacheKey(domain))) {
        return null;
    }
    return THEME_PREFERENCES.includes(event.newValue) ? event.newValue : 'AUTO';
}

export function resolveBootTheme({ pathname, preference, systemDark }) {
    return resolveThemeMode({
        pathname,
        preference: preference || 'AUTO',
        systemDark,
    });
}
